import { Box, CircularProgress, Typography } from "@mui/material";
import { LineChart } from "@mui/x-charts/LineChart";

interface Props {
    xAxisData?: string[];
    yAxisData?: number[];
    title?: string;
    isLoading?:boolean;
    hasError?: boolean;
}

const LeadsAccumulatedGraph = ({
    xAxisData = [],
    yAxisData = [],
    title = "Leads by day of week",
    isLoading = false,
    hasError = false
}: Props) => {
    // Calculate max value for y-axis with some padding
    const maxValue = yAxisData.length > 0 ? Math.max(...yAxisData) + 5 : 31;


    return (
        <Box sx={{
            width: "100%",
            border: "solid 1px #0000001F",
            display: "flex",
            flexDirection: "column",
            borderRadius: "24px",
            mt: "24px",
            overflow: "visible",
            minHeight: "600px"
        }}>
            <Box sx={{ display: "flex", justifyContent: "flex-start", mb: 1, p: 2 }}>
                <Typography variant="title_medium">{title}</Typography>
            </Box>

            {
                isLoading? (<Box sx={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <CircularProgress />
          </Box> ) : hasError ? (<Box sx={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Typography color="text.secondary">
             Error in displaying graph data
            </Typography>
          </Box>):(
             <Box sx={{
                width: "100%",
                height: "550px", // Increased height to accommodate labels
                display: "flex",
                alignItems: "stretch",
                justifyContent: "stretch",
                overflow: "visible"
            }}>
                <LineChart
                    xAxis={[{
                        data: xAxisData,
                        scaleType: "point",
                        tickLabelStyle: {
                            angle: -90,
                            textAnchor: "end",
                            fontSize: 9,
                            fill: "#666"
                        },
                        tickMinStep: 1,
                        tickMaxStep: 1,
                    }]}
                    yAxis={[{
                        min: 0,
                        max: maxValue
                    }]}
                    series={[
                        {
                            data: yAxisData,
                            color: "#ff8c00",
                            curve: "catmullRom",
                            showMark: false,
                            area: true,
                            stack: "total"
                        },
                    ]}
                    height={550}
                    margin={{ left: 50, right: 30, top: 20, bottom: 120 }} // Increased bottom margin for full label display
                    slotProps={{
                        legend: { hidden: true },
                        axisContent: {
                            sx: {
                                "& .MuiChartsAxis-tickLabel": {
                                    fontSize: "0.6rem !important",
                                    display: "block !important",
                                }
                            }
                        }
                    }}
                    sx={{
                        width: "100%",
                        maxWidth: "100%",
                        "& .MuiLineElement-root": {
                            strokeWidth: 3,
                        },
                        "& .MuiMarkElement-root": {
                            fill: "#ff8c00",
                            stroke: "#ff8c00",
                            strokeWidth: 2,
                            r: 5,
                        },
                        "& .MuiAreaElement-root": {
                            fill: "url(#orangeGradient)",
                        },
                        "& .MuiChartsAxis-tickLabel": {
                            fontSize: "0.75rem",
                            fill: "#666",
                        },
                        // Ensure x-axis labels are fully visible and force all labels to show
                        "& .MuiChartsAxis-bottom .MuiChartsAxis-tickLabel": {
                            fontSize: "0.6rem",
                            fill: "#666",
                            display: "block !important",
                            visibility: "visible !important",
                        },
                        // Force all ticks to be visible
                        "& .MuiChartsAxis-bottom .MuiChartsAxis-tick": {
                            display: "block !important",
                        },
                        "& .MuiChartsAxis-line": {
                            stroke: "#e0e0e0",
                        },
                        "& .MuiChartsGrid-line": {
                            stroke: "#f0f0f0",
                            strokeDasharray: "none",
                        },
                    }}
                >
                    <defs>
                        <linearGradient id="orangeGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                            <stop offset="0%" stopColor="#ff8c00" stopOpacity={0.8} />
                            <stop offset="50%" stopColor="#ffb347" stopOpacity={0.4} />
                            <stop offset="100%" stopColor="#ffe4b5" stopOpacity={0.1} />
                        </linearGradient>
                    </defs>
                </LineChart>
            </Box>

          )
            }
           
        </Box>
    )
}

export default LeadsAccumulatedGraph;